import Mustache from 'mustache'

/**
 * App news class
 */

class News {

  constructor() {
    this.el = document.querySelector('.js-app-news')
    this.filters = document.querySelector('.js-app-news-filters')
    this.filterButtons = document.querySelectorAll('.js-app-news-button')
    this.list = document.querySelector('.js-app-news-list')
    this.tplFilters = document.querySelector('.js-template-app-news-filters')?.innerText
    this.tplList = document.querySelector('.js-template-app-news-list')?.innerText
    this.tplItem = document.querySelector('.js-template-app-news-item')?.innerText
    this.lang = document.querySelector('html').getAttribute('lang')
    this.action = document.querySelector('.js-app-news')?.getAttribute('data-action') || '/stage-ajax/app-news'
    this.data = {
      filters: [],
      limit: 12,
      types: [],
      items: [],
      hasMore: false,
      showMoreAmount: 8
    }
  }

  /**
   * Init App
   */
  init() {
    this.getParams()
    this.getData()
  }

  /**
   * Get parameters that might be given in custom element
   */
  getParams() {
    this.el.getAttribute('data-type') && this.el.getAttribute('data-type') !== '' ? this.data.filters.push(this.el.getAttribute('data-type')) : []
    this.el.getAttribute('data-limit') && this.el.getAttribute('data-limit') !== '' ? this.data.limit = this.el.getAttribute('data-limit') : []
  }

  /**
   * Get data from endpoint (stage-ajax)
   */
  async getData() {
    let fetchUrl = `${this.action}?stage-language=${this.lang}&limit=${this.data.limit}`
    this.data.filters.length > 0 ? fetchUrl = fetchUrl + `&${this.data.filters.map((item) => { return 'filters[]='+item}).join('&')}` : []
    await fetch(fetchUrl)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        this.data.items = data.items
        this.data.types = data.types
        this.data.hasMore = data.hasMore
        this.data.showMoreAmount = data.showMoreAmount || this.data.showMoreAmount;
        this.renderFilters()
        this.renderList()
      })
  }

  /**
   * Attach listeners
   */
  listeners() {
    document.querySelectorAll('.js-app-news-button').forEach((button) => {
      this.data.filters.length > 0 && this.data.filters.includes(button.getAttribute('data-type')) ? button.classList.add('active') : button.classList.remove('active')
      this.data.filters.length === 0 ? button.classList.add('active') : []
      button.addEventListener('click', (e) => {
        e.preventDefault()
        let type = e.target.getAttribute('data-type')
        this.data.filters.includes(type) ? this.data.filters = this.data.filters.filter(item => item !== type) : this.data.filters.push(type)
        this.getData()
      })
    })
    document.querySelector('.js-app-news-show-more')?.addEventListener('click', (e) => {
      e.preventDefault()
      this.data.limit = this.data.limit + this.data.showMoreAmount
      this.getData()
    })
  }

  /**
   * Render filter buttons
   */
  renderFilters() {
    this.render({
      target: this.filters,
      html: Mustache.render(this.tplFilters, this.data)
    })
  }

  /**
   * Render list and items
   */
  renderList() {
    this.render({
      target: this.list,
      html: Mustache.render(this.tplList, this.data, { childTemplate: this.tplItem })
    })
    this.listeners()
  }

  /**
   * Set elements (target) html to given html
   * @param {Object} params target and html are required
   */
  render(params = {}) {
    if (params.target && params.html) {
      params.target.innerHTML = params.html
    }
  }

}

export default new News()
